import { tv } from 'tailwind-variants';

export const scrollableTableWrapperVariants = tv({
  slots: {
    wrapper: ['relative'],
    hint: [
      'text-end',
      'font-medium',
      'text-primary',
      'pointer-events-none',
      'whitespace-nowrap',
      'my-2.5',
    ],
    hintInner: ['inline-flex', 'items-center', 'gap-0.5', 'font-medium'],
    scrollContainer: ['overflow-x-auto'],
    fadeStart: [
      'pointer-events-none',
      'absolute',
      '-left-[2px]',
      'top-0',
      'bottom-0',
      'z-10',
      'w-6',
      'bg-linear-to-r',
      'from-white',
      'via-white/70',
      'to-transparent',
    ],
    fadeEnd: [
      'pointer-events-none',
      'absolute',
      '-right-[2px]',
      'top-0',
      'bottom-0',
      'z-10',
      'w-6',
      'bg-linear-to-l',
      'from-white',
      'via-white/70',
      'to-transparent',
    ],
  },
});
